import { render, staticRenderFns } from "./ItemCheck.vue?vue&type=template&id=280623b8&"
import script from "./ItemCheck.vue?vue&type=script&lang=js&"
export * from "./ItemCheck.vue?vue&type=script&lang=js&"
import style0 from "./ItemCheck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports